import { differenceInMinutes, differenceInHours, differenceInDays, parseISO } from 'date-fns';

const formatTimeAgo = (date: Date) => {

    const now = new Date();
    
    const days = differenceInDays(now, date);
    const hours = differenceInHours(now, date) % 24;
    const minutes = differenceInMinutes(now, date) % 60;

    if (days > 0) {
        return `${days} päeva`;
    }
    if (hours > 0) {
        return `${hours} tundi`;
    } if (minutes > 0) {
        return `${minutes} min`;
    }
    return `Hetk tagasi`;
}

export default formatTimeAgo;